import { Box, CircularProgress } from '@material-ui/core';

const AsyncSuspenseFallbackLoader = () => (
  <Box
    style={{
      width: '100%',
      height: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    }}
  >
    <CircularProgress style={{ color: 'white', width: 20, height: 20 }} />
  </Box>
);
export { AsyncSuspenseFallbackLoader };
